<template>
  <div class="year-main-content">
    <div class="year-top-image" v-bind:style="{ backgroundImage: 'url(' + require('@/assets/' + topImage) + ')' }">
    <div class="year-overlay"><span>2019</span></div>
    </div>
    <div class="view-wrap yr2019">

      

<FullYearStats fullGames='11' fullCompletions='281' fullAttempts='378' fullYards='2979' fullPct='74.3' fullTDs='27' fullINTs='4' fullYPG='270.8' fullRating='116.3'></FullYearStats>

  <div class="year-summary-wrapper">
    <div class="triangle-top-left"></div>
    <div class="triangle-bottom-right"></div>
    <div class="year-summary">
    
      <div class="year-summary-text-flex">


<div class="awards-wrapper">
        <div class="awards-headline">2019 Awards</div>
        <ul>

          <li><img :src="require('@/assets/pro-bowl.png')" alt="Pro Bowl Logo"> 2019 Pro Bowl</li>

          
        </ul>
        <div class="awards-legend">
<b>AP</b> - Associated Press, <b>CN</b> - College & Pro Football Weekly, <b>FD</b> -Football Digest, <b>FN</b> -Football News, <b>FW</b> - Professional Football Writers of America, <b>NE</b> - Newspaper Enterprise Association, <b>NY</b> - New York Daily News, <b>PFWA</b> - Pro Football Writers of America, <b>PW</b> - Pro Football Weekly(1992-2012,choices combined with Pro Football Writers of America), <b>SI</b> - Sports Illustrated, <b>SN</b> - Sporting News, <b>UP</b> - United Press International, <b>UW</b> - USA Today/Sports Weekly
        </div>
      </div> 
      </div> <!--end text-flex-->
  </div>




</div>



   <div class="bubble-chart-wrapper chart-light">
      <h2 class="chart-headline">Top Rated QBs of 2019</h2>
      <BubbleChart :chart-data="dataBubble1" :options="dataOptions3" style="height:400px;"></BubbleChart>
    </div>


<div class="touchdowns-header-wrapper">
  <h1><img src="https://nolaprodigital.com/saints/brees500/images/referee-icon-white.png" alt="Drew Brees 2019 Touchdown Tally"> 2019 TOUCHDOWN TALLY</h1>
</div>

<TDsByYear :tds="this.tds"></TDsByYear>


<flickity ref="flickity" :options="flickityOptions">
  <div class="carousel-cell"><img :src="require('@/assets/' + image1)" alt="Drew Brees in 2019 - Slide1"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image2)" alt="Drew Brees in 2019 - Slide2"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image3)" alt="Drew Brees in 2019 - Slide3"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image4)" alt="Drew Brees in 2019 - Slide4"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image5)" alt="Drew Brees in 2019 - Slide5"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image6)" alt="Drew Brees in 2019 - Slide6"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image7)" alt="Drew Brees in 2019 - Slide7"></div>
  <div class="carousel-cell"><img :src="require('@/assets/' + image8)" alt="Drew Brees in 2019 - Slide8"></div>
</flickity>


<div class="year-pagination-wrapper">
  <div class="year-pagination-section year-pagination-prev"><router-link to="/year/2018">«2018</router-link></div>
  <div class="year-pagination-section year-pagination-current">2019</div>
  <div class="year-pagination-section year-pagination-next"><router-link to="/year/2020">2020»</router-link></div>
</div>


    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import StatsFlex from '@/components/StatsFlex.vue'
import Flickity from 'vue-flickity';
import VideoBtn from '@/components/VideoBtn.vue';
import FullYearStats from '@/components/FullYearStats.vue';
import TDsByYear from '@/components/TDsByYear.vue';
import BubbleChart from '@/components/BubbleChart.vue'

import axios from 'axios';

export default {
  name: 'yr2019',
  components: {
    Flickity,
    StatsFlex,
    VideoBtn,
    FullYearStats,
    TDsByYear,
    BubbleChart
  },
  metaInfo: {
    title: 'Drew Brees Stats and Touchdowns from his 2019 season',
    htmlAttrs: {
      lang: 'en'
    }
  },
  data() {
    return {
      tds: {},
      loading: false,
      games: [],
      topImage: "brees-2019-top-image.jpg",
      image1: "brees-2019-slide-1.jpg",
      image2: "brees-2019-slide-2.jpg",
      image3: "brees-2019-slide-3.jpg",
      image4: "brees-2019-slide-4.jpg",
      image5: "brees-2019-slide-5.jpg",
      image6: "brees-2019-slide-6.jpg",
      image7: "brees-2019-slide-7.jpg",
      image8: "brees-2019-slide-8.jpg",

      flickityOptions: {
            initialIndex: 0,
            prevNextButtons: false,
            pageDots: false,
            resize: true,
            wrapAround: true,
            autoPlay: true

            // any options from Flickity can be used
            }

          } 
        },
  methods: {
    async getTDs() {
      const self = this;
      const response = await axios.get(
        "../../static/td-data.json"
      );
      this.tds = response.data.y2019;
      console.log(this.tds)
    },
    next() {
      this.$refs.flickity.next();
    },

    previous() {
      this.$refs.flickity.previous();
    },
    resize() {
      this.$refs.flickity.resize();
    }
  },

    mounted: function() {
    this.getTDs();

    setTimeout(() => {
    this.$refs.flickity.resize();
    }, 2000)


    },
    created() {
       this.dataBubble1 = {
      "datasets": [
      {
        "label": "Drew Brees",
        "backgroundColor": "black",
        "borderColor": "#D3BC8D",
        "fill": false,
        "pointBackgroundColor": '#D3BC8D',
        "pointColor": "#D3BC8D",
        "pointRadius": 100,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#D3BC8D",
        data: [
                {
                  x: 116.3,
                  y: 74.3,
                  r: 4*3
                }
              ]
      },
      {
        "label": "Russell Wilson",
        "backgroundColor": "#69BE28",
        "borderColor": "#002244",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 106.3,
                  y: 66.1,
                  r: 5*3
                }
              ]
      },
      {
        "label": "Patrick Mahomes",
        "backgroundColor": "#FFB81C",
        "borderColor": "#E31837",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 105.3,
                  y: 65.9,
                  r: 5*3
                }
              ]
      },
      {
        "label": "Ryan Tannehill",
        "backgroundColor": "#4B92DB",
        "borderColor": "#C8102E",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 117.5,
                  y: 70.3,
                  r: 6*3
                }
              ]
      },
      {
        "label": "Lamar Jackson",
        "backgroundColor": "#241773",
        "borderColor": "#9E7C0C",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 113.3,
                  y: 66.1,
                  r: 6*3
                }
              ]
      }
      ]
    },
    this.dataOptions3 = {
        "responsive": true,
        "maintainAspectRatio": false,
        title: {
            display: true,
            text: '2019 TOP QBs (Bubble size is interceptions)'
        },
        "layout": {
          padding: {
                left: 10,
                right: 10,
                top: 0,
                bottom: 0
          },
        },
        "legend": {
          "position" : "bottom",
            "maxSize" : {
                "height" : 400
            },
            "labels": {
                "fontColor": "black",
                "fontSize": 14,
                "usePointStyle" : true
            }
        },
        tooltips: {
          "mode": "point",
          callbacks: {
              label: function(tooltipItem, data) {
                 var rLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].r;
                  var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
                  return datasetLabel + ' : ' + tooltipItem.yLabel + ' COMP%, ' + tooltipItem.xLabel + ' QB RATING, ' + rLabel/3 + ' INTs';
              }
          }
        },
        "scales": {
          "yAxes": [{
            scaleLabel: {
              display: true,
              labelString: 'Completion Percentage'
            },
            gridLines: {
              color: '#D3BC8D',
              tickMarkLength: 20,
              lineWidth: .2
                },
            "ticks": {
              "fontColor": 'black',
              callback: function(value, index, values) {
                        return value + '%';
                    },
            },
          }],
          "xAxes": [{
            scaleLabel: {
              display: true,
              labelString: 'Quarterback Rating'
            },
            gridLines: {
              color: '#D3BC8D',
              tickMarkLength: 20,
              lineWidth: .2
            },
            "ticks": {
              
              "fontColor": 'black'
            },
          }]
        }
    }
  }
}
</script>

<style>

.external-link  {
    border-bottom: 3px solid #D3BC8D;
    transition-duration: .25s;
    color:black;
    text-decoration:none;
}
.external-link:hover {
    background: #D3BC8D;
    transition-duration: .25s;
}


.year-top-image > img {
  width:100%;
}


@media (max-width:767px;) {
  .year-main-content {
  margin-top:35px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/yr2019.vue